import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=56fe819e&scoped=true&"
import script from "./Customers.vue?vue&type=script&lang=js&"
export * from "./Customers.vue?vue&type=script&lang=js&"
import style0 from "./Customers.vue?vue&type=style&index=0&id=56fe819e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fe819e",
  null
  
)

export default component.exports